import React, { useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

import Card from './Card';
import useWindowSize from '../hooks/useWindowSize';

const SharpComContainer = styled.div`
  margin: 0 auto;
  padding: 0 2.5rem;
  box-sizing: border-box;

  @media only screen and (min-width: 1281px) {
    width: 1280px;
  }

  @media only screen and (min-width: 1025px) and (max-width: 1280px) {
    width: 100%;
  }

  @media only screen and (max-width: 607px) {
    padding: 0 10px;
    width: 100%;
  }
`;
SharpComContainer.displayName = 'SharpComContainer';

const SharpComRow = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
  clear: both;

  @media (max-width: 767px) {
    padding-top: 2.5rem;
  }
`;
SharpComRow.displayName = 'SharpComRow';

const HeaderBlock = styled.div`
  max-width: 900px;
  text-align: center;
  margin: auto;
  padding-bottom: 2.5rem;

  h1 {
    padding: 0;
  }

  .description {
    width: 54%;
    margin: auto;
    padding: 1.25rem 0 0 0;
  }

  @media (max-width: 768px) {
    padding-bottom: 1.25rem;

    h1 {
      width: 90%;
      font-size: 28px;
      line-height: 1.29;
      margin: auto;
    }

    .description {
      width: 90%;
    }
  }
`;
HeaderBlock.displayName = 'HeaderBlock';


const CardCollection = styled.div`
  display: grid;
  grid-template-columns: repeat( 3, 1fr );
  column-gap: 1.25rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    row-gap: 1.25rem;
    justify-content: center;
  }
`;
CardCollection.displayName = 'CardCollection';

const FooterText = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 0;

  .emergency-bottom-content {
    padding-top: 1.25rem;
    text-align: center;
    color: #42484d;
    width: 79%;
    margin: auto;
  }

  .bottom-link-emerg a {
    padding-bottom: 0;
    font-weight: 600;
    color: #2680ad;
  }

  .bottom-link-emerg a:hover {
    color: #3e6d85;
    border-bottom: 1px solid #3e6d85;
  }

  @media (min-width: 768px) {
    .emergency-bottom-content {
      padding-top: 2.5rem;
    }
  }
`;
FooterText.displayName = 'FooterText';

export default (props) => {
  const size = useWindowSize();
  // const jsonState = typeof props.props.dropDown === 'boolean';
  const jsonState = props.props.dropDown;
  const sizeChecker = size > 1024;
  const [dropDown, setDropDown] = useState(
    typeof jsonState === 'boolean' ? jsonState : sizeChecker
  );

  const dropDownAnalyticsExpandId = props.props.dropDownAnalyticsExpandId;
  const dropDownAnalyticsCollapseId = props.props.dropDownAnalyticsCollapseId;

  return (
    <SharpComContainer>
      <SharpComRow>
        {(props.props.headerTitle || props.props.headerText) &&
          <HeaderBlock>
            {props.props.headerTitle &&
              <h1 data-testid='page-title'>{props.props.headerTitle}</h1>
            }
            {props.props.headerText &&
              <p className='description'><span dangerouslySetInnerHTML={{ __html: props.props.headerText }}></span></p>
            }
          </HeaderBlock>
        }
        <CardCollection>
          {props.props.columns.map(
            (
              {
                title,
                text,
                button,
                buttonLink,
                dollar,
                body,
                buttonAnalyticsId,
                buttonLabel,
                bannerText,
                features,
              },
              index
            ) => (
              <Card
                sizeChecker={sizeChecker}
                dropDown={dropDown}
                setDropDown={setDropDown}
                key={index}
                title={title}
                text={text}
                button={button}
                buttonLink={buttonLink}
                dollar={dollar}
                body={body}
                buttonLabel={buttonLabel}
                dropDownAnalyticsExpandId={dropDownAnalyticsExpandId}
                dropDownAnalyticsCollapseId={dropDownAnalyticsCollapseId}
                buttonAnalyticsId={`${buttonAnalyticsId}-${index}`}
                bannerText={bannerText}
                features = {features}
              />
            )
          )}
        </CardCollection>

        {/* FOOTER TEXT */}
        {(props.props.footerText &&
          <FooterText>
            <p className="emergency-bottom-content">
              <FontAwesomeIcon icon={faExclamationTriangle} />{' '}
              <span
                className='bottom-link-emerg'
                dangerouslySetInnerHTML={{ __html: props.props.footerText }}
              ></span>
            </p>
          </FooterText>
        )}

      </SharpComRow>
    </SharpComContainer>
  );
};
